const formatNumber2Digits = (n) => (n < 10 ? `0${n}` : n);

export const getFormatTime = (date) => {
  const hour = new Date(date).getHours();
  const minutes = new Date(date).getMinutes();

  return `${formatNumber2Digits(hour)}:${formatNumber2Digits(minutes)}`;
};
